import React, { useState } from 'react';

const RegisterForm = ({ onRegister, onSwitchToLogin, error }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');

    const validateForm = () => {
        if (password !== confirmPassword) {
            setValidationError('Пароли не совпадают');
            return false;
        }
        if (password.length < 6) {
            setValidationError('Пароль должен содержать минимум 6 символов');
            return false;
        }
        if (!email.includes('@')) {
            setValidationError('Введите корректный email');
            return false;
        }
        if (username.length < 3) {
            setValidationError('Имя пользователя должно содержать минимум 3 символа');
            return false;
        }
        setValidationError('');
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        
        setLoading(true);
        await onRegister({ username, email, password });
        setLoading(false);
    };

    return (
        <div style={{ padding: '1rem' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <i className="fas fa-leaf" style={{ color: 'var(--primary)' }}></i> Регистрация
            </h3>
            
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        <i className="fas fa-user"></i> Имя пользователя
                    </label>
                    <input
                        type="text"
                        className="message-input"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Введите имя пользователя"
                        required
                        style={{ width: '100%' }}
                    />
                </div>
                
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        <i className="fas fa-envelope"></i> Email
                    </label>
                    <input
                        type="email"
                        className="message-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Введите email"
                        required
                        style={{ width: '100%' }}
                    />
                </div>
                
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        <i className="fas fa-lock"></i> Пароль
                    </label>
                    <input
                        type="password"
                        className="message-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Минимум 6 символов"
                        required
                        style={{ width: '100%' }}
                    />
                </div>
                
                <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        <i className="fas fa-lock"></i> Подтвердите пароль
                    </label>
                    <input
                        type="password"
                        className="message-input"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Повторите пароль"
                        required
                        style={{ width: '100%' }}
                    />
                </div>
                
                {(validationError || error) && (
                    <div style={{ 
                        background: 'rgba(231, 76, 60, 0.1)', 
                        color: '#e74c3c', 
                        padding: '0.5rem',
                        borderRadius: '8px',
                        marginBottom: '1rem',
                        fontSize: '0.85rem',
                        textAlign: 'center'
                    }}>
                        <i className="fas fa-exclamation-triangle"></i> {validationError || error}
                    </div>
                )}
                
                <button 
                    type="submit" 
                    className="btn-primary" 
                    disabled={loading}
                    style={{ width: '100%', marginBottom: '1rem' }}
                >
                    {loading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-user-plus"></i>} 
                    {loading ? ' Регистрация...' : ' Зарегистрироваться'}
                </button>
                
                <p style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                    Уже есть аккаунт?{' '}
                    <button 
                        type="button"
                        onClick={onSwitchToLogin}
                        style={{ 
                            background: 'none', 
                            border: 'none', 
                            color: 'var(--primary)',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }}
                    >
                        Войти
                    </button>
                </p>
            </form>
        </div>
    );
};

export default RegisterForm;
